import { render } from "./ValidateOtp.vue?vue&type=template&id=520c1920"
import script from "./ValidateOtp.vue?vue&type=script&lang=js"
export * from "./ValidateOtp.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Build Apps\\jlm_app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__